import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function isLoadingSelector(state: IInitialState) {
	return moduleStateSelector(state).isLoading;
}
